
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "getScenario",
      resolverType: "query",
      routePath: "/getScenario",
      httpMethod: "POST",
    });
  